import React, { useEffect, useState } from 'react'
import { Row, Col, Modal, ModalBody } from 'reactstrap';
import { MenuDasFuncionalidades } from "../Menu";
import { connect } from 'react-redux';
import * as actionsRedux from '../Store/Actions/index';
import AlunosIcon from '../Icons/Alunos';
import ProfessorIcon from '../Icons/Professor';
import UsuariosIcon from '../Icons/Usuarios';
import BarGraph from '../Conteudo/Graficos/BarGraph';
import { axiosApi } from '../Basicos/axiosInstances';
import { NewLoader } from '../Basicos';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LabelList } from 'recharts';

function Dashboard({
    ativarAlert
}) {
    const [cursos, setCursos] = useState([]);
    const [periodosLetivos, setPeriodosLetivos] = useState([]);
    const [semestres, setSemestres] = useState([]);
    const [turmas, setTurmas] = useState([]);
    const [professores, setProfessores] = useState([]);
    const [tiposAtividades, setTiposAtividades] = useState([]);
    const [temas, setTemas] = useState([]);
    const [status, setStatus] = useState([]);
    const [dadosFiltrados, setDadosFiltrados] = useState([]);
    const [defaultFiltros, setDefaultFiltros] = useState(null);
    const [count, setCount] = useState([]);
    const [acessosProfessores, setAcessosProfessores] = useState([]);
    const [qtdAtividades, setQtdAtividades] = useState([]);
    const [professoresComAula, setProfessoresComAula] = useState([]);
    const [professoresComAulaCompleto, setProfessoresComAulaCompleto] = useState([]);
    const [provasPendentes, setProvasPendentes] = useState([]);
    const [paginaAtual, setPaginaAtual] = useState(1);
    const [paginaAtualProvas, setPaginaAtualProvas] = useState(1);
    const [filtroTurno, setFiltroTurno] = useState('Todas');
    const [modalOpen, setModalOpen] = useState(false);
    const [aulaSelecionada, setAulaSelecionada] = useState(null);
    const [modalAtividadeOpen, setModalAtividadeOpen] = useState(false);
    const [atividadeSelecionada, setAtividadeSelecionada] = useState(null);
    const itensPorPagina = 5;
    const itensPorPaginaProvas = 5;
    const [isLoading, setIsLoading] = useState(false);

    const toggleModal = () => setModalOpen(!modalOpen);
    const toggleModalAtividade = () => setModalAtividadeOpen(!modalAtividadeOpen);

    const handleOpenModal = (item) => {
        setAulaSelecionada(item);
        setModalOpen(true);
    };

    const handleAtividadeClick = (data) => {
        setAtividadeSelecionada(data);
        setModalAtividadeOpen(true);
    };

    const getProfessoresFiltrados = () => {
        if (!professoresComAula) return [];
        switch (filtroTurno) {
            case 'AB Manhã': return professoresComAula.filter(item => item.horario_curso_id === 1);
            case 'CD Manhã': return professoresComAula.filter(item => item.horario_curso_id === 2);
            case 'AB Tarde': return professoresComAula.filter(item => item.horario_curso_id === 3);
            case 'CD Tarde': return professoresComAula.filter(item => item.horario_curso_id === 4);
            default: return professoresComAula;
        }
    };

    const professoresFiltrados = getProfessoresFiltrados();
    const totalPaginas = Math.ceil(professoresFiltrados.length / itensPorPagina);
    const idxInicio = (paginaAtual - 1) * itensPorPagina;
    const idxFim = idxInicio + itensPorPagina;
    const itensPaginaAtual = professoresFiltrados.slice(idxInicio, idxFim);

    const handlePreviousPage = () => {
        if (paginaAtual > 1) setPaginaAtual(paginaAtual - 1);
    };

    const handleNextPage = () => {
        if (paginaAtual < totalPaginas) setPaginaAtual(paginaAtual + 1);
    };

    const totalPaginasProvas = Math.ceil(provasPendentes.length / itensPorPaginaProvas);
    const idxInicioProvas = (paginaAtualProvas - 1) * itensPorPaginaProvas;
    const idxFimProvas = idxInicioProvas + itensPorPaginaProvas;
    const provasPaginaAtual = provasPendentes.slice(idxInicioProvas, idxFimProvas);

    const handlePreviousPageProvas = () => {
        if (paginaAtualProvas > 1) setPaginaAtualProvas(paginaAtualProvas - 1);
    };

    const handleNextPageProvas = () => {
        if (paginaAtualProvas < totalPaginasProvas) setPaginaAtualProvas(paginaAtualProvas + 1);
    };

    const formatarData = (dataStr) => {
        if (!dataStr) return '';
        const [ano, mes, dia] = dataStr.substring(0, 10).split('-');
        return `${dia}/${mes}/${ano}`;
    };

    const handleFiltroTurno = (novoFiltro) => {
        if (filtroTurno !== novoFiltro) {
            setFiltroTurno(novoFiltro);
            setPaginaAtual(1);
        }
    };

    const [valoresFiltro, setValoresFiltro] = useState({
        curso_id: 17,
        periodo_letivo_id: 9,
        semestre_id: undefined,
        tema_id: undefined,
        turma_id: undefined,
        professor_id: undefined,
        tipo_atividade_id: undefined,
        status_id: 0
    })

    const getDadosDashboard = async (filtros = valoresFiltro) => {
        try {
            setIsLoading(true);
            const { data } = await axiosApi.post('/dashboards', filtros)
            const { count, professoresAcessos, qtdAtividades, professoresComAula, provasPendentes, professoresComAulaCompleto } = data.dados
            setCount(count);
            setAcessosProfessores(professoresAcessos);
            setQtdAtividades(qtdAtividades || []);
            setProfessoresComAula(professoresComAula || []);
            setProfessoresComAulaCompleto(professoresComAulaCompleto || []);
            setProvasPendentes(provasPendentes || []);
            setPaginaAtual(1);
            setPaginaAtualProvas(1);
            setFiltroTurno('Todas');
        } catch (error) {
            console.log(error)
            if (error.response.status === 403) {
                ativarAlert(400, error?.response?.data?.mensagem);
            }
        } finally {
            setIsLoading(false);
        }
    }
    const getOptions = async () => {
        try {
            const { data } = await axiosApi.get('/dashboards/options')
            const { temas, semestre, semestres, periodo, periodosLetivos, cursos, curso, turmas, professores, tiposAtividade, status, periodoLetivoVigente, data_inicio, data_fim } = data.dados

            const listSemestres = semestres || semestre || [];
            const listPeriodos = periodosLetivos || periodo || [];
            const listCursos = curso || cursos || [];

            const formatOptions = (arr) => arr ? arr.map(i => ({ ...i, value: i.id || i.value, label: i.descricao || i.nome || i.nome_social || i.label || i.id })) : [];

            setSemestres(formatOptions(listSemestres));
            setPeriodosLetivos(formatOptions(listPeriodos));
            setCursos(formatOptions(listCursos));
            setTurmas(formatOptions(turmas));
            setProfessores(formatOptions(professores));
            setTiposAtividades(formatOptions(tiposAtividade));
            setStatus(formatOptions(status));
            setTemas(formatOptions(temas));

            const initialFiltros = {
                curso_id: 17,
                periodo_letivo_id: periodoLetivoVigente?.id || 9,
                semestre_id: undefined,
                tema_id: undefined,
                turma_id: undefined,
                professor_id: undefined,
                tipo_atividade_id: undefined,
                status_id: 0,
                data_inicial: data_inicio,
                data_final: data_fim
            };

            setValoresFiltro(initialFiltros);
            setDefaultFiltros(initialFiltros);

            // Initial data fetch
            getDadosDashboard(initialFiltros);

        } catch (error) {
            console.log(error)
        }
    }

    const getTemas = async (semestre_id) => {
        try {
            const { data } = await axiosApi.get(`/dashboards/temas-semestre?semestre_id=${semestre_id}`)
            const formatOptions = (arr) => arr ? arr.map(i => ({ ...i, value: i.id || i.value, label: i.descricao || i.nome || i.nome_social || i.label || i.id })) : [];
            setTemas(formatOptions(data.temas));
        } catch (error) {
            console.log(error)
        }
    }

    const getProfessoresFiltro = async (filtrosNova = valoresFiltro) => {
        try {
            const params = {
                semestre_id: filtrosNova.semestre_id,
                tema_id: filtrosNova.tema_id,
                tipo_atividade_id: filtrosNova.tipo_atividade_id
            }
            const { data } = await axiosApi.get('/professores-filtro', { params })
            const formatOptions = (arr) => arr ? arr.map(i => ({ ...i, value: i.id || i.value, label: i.descricao || i.nome || i.nome_social || i.label || i.id })) : [];
            setProfessores(formatOptions(data.professores));
        } catch (error) {
            console.log(error)
        }
    }


    const iconCard = (index) => {
        switch (index) {
            case 0:
                return <AlunosIcon width="3rem" height="3rem" color='white' />
            case 1:
                return <ProfessorIcon width="3rem" height="3rem" color='white' />
            case 2:
                return <UsuariosIcon width="4rem" height="4rem" color='white' />
            default:
                break;
        }
    }

    const handleFiltrar = () => {
        getDadosDashboard();
    }

    const handleLimpar = () => {
        if (defaultFiltros) {
            setValoresFiltro(defaultFiltros);
            getDadosDashboard(defaultFiltros);
        }
    }

    // useEffect(() => { getDadosDashboard() }, [valoresFiltro])
    useEffect(() => { getOptions() }, [])

    // console.log(valoresFiltro)
    return (
        <Row noGutters>
            <MenuDasFuncionalidades
                funcionalidade={"dashboard"}
                classNavBar="navbar-consultas"
                titulo="Dashboard"
                options={[
                    cursos,
                    periodosLetivos,
                    semestres,
                    turmas,
                    professores,
                    tiposAtividades,
                    temas,
                    status
                ]}
                setDadosFiltrados={setDadosFiltrados}
                setValoresFiltro={setValoresFiltro}
                valoresFiltro={valoresFiltro}
                getTemas={getTemas}
                getProfessoresFiltro={getProfessoresFiltro}
                handleFiltrar={handleFiltrar}
                handleLimpar={handleLimpar}
                isActive={cursos && cursos.length > 0}
            />
            <NewLoader isActive={isLoading} overlay >
                <Col md="12">
                    <div style={{ backgroundColor: '#fff', borderRadius: '8px', padding: '20px', margin: '20px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', border: '1px solid #e0e0e0' }}>
                        <h4 style={{ fontWeight: 'bold', marginBottom: '20px', color: '#1a1a1a' }}>Aulas por Tipo de Atividade</h4>
                        {qtdAtividades && qtdAtividades.length > 0 ? (
                            <div style={{ width: '100%', height: 350 }}>
                                <ResponsiveContainer width="100%" height="100%">
                                    <BarChart
                                        data={qtdAtividades}
                                        margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" vertical={true} />
                                        <XAxis
                                            dataKey="tipo_atividade_id"
                                            tickFormatter={(id) => qtdAtividades.find(i => i.tipo_atividade_id === id)?.tipo_atividade_abreviatura}
                                            tick={{ fontSize: 12, fill: '#666' }}
                                            axisLine={{ stroke: '#ccc' }}
                                            tickLine={false}
                                        />
                                        <YAxis
                                            axisLine={false}
                                            tickLine={false}
                                            tick={{ fontSize: 12, fill: '#666' }}
                                        />
                                        <Tooltip
                                            cursor={{ fill: '#f5f5f5' }}
                                            labelFormatter={(id) => {
                                                const item = qtdAtividades.find(i => i.tipo_atividade_id === id);
                                                return item ? item.tipo_atividade_nome : id;
                                            }}
                                        />
                                        <Bar
                                            dataKey="total_aulas"
                                            name="Total Aulas"
                                            fill="#1A23DF"
                                            radius={[4, 4, 0, 0]}
                                            barSize={40}
                                            onClick={(data) => handleAtividadeClick(data.payload || data)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <LabelList dataKey="total_aulas" position="top" style={{ fontSize: '13px', fontWeight: 'bold', fill: '#1A23DF' }} />
                                        </Bar>
                                    </BarChart>
                                </ResponsiveContainer>
                            </div>
                        ) : (
                            <div style={{ textAlign: 'center', padding: '40px 20px', color: '#666' }}>
                                <p>Nenhum dado de aula encontrado para o filtro selecionado.</p>
                            </div>
                        )}
                    </div>
                </Col>

                <Col md="12">
                    <div style={{ backgroundColor: '#fff', borderRadius: '8px', padding: '20px', margin: '0 20px 20px 20px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', border: '1px solid #e0e0e0' }}>
                        {professoresComAula && professoresComAula.length > 0 ? (
                            <>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '15px' }}>
                                    <h4 style={{ fontWeight: 'bold', margin: '0', color: '#1a1a1a', minWidth: '250px' }}>Professores com Aulas - Hoje</h4>

                                    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', justifyContent: 'flex-end', flex: 1 }}>
                                        {['Todas', 'AB Manhã', 'CD Manhã', 'AB Tarde', 'CD Tarde'].map((btn) => (
                                            <button
                                                key={btn}
                                                onClick={() => handleFiltroTurno(btn)}
                                                style={{
                                                    padding: '6px 14px',
                                                    border: filtroTurno === btn ? 'none' : '1px solid #ccc',
                                                    backgroundColor: filtroTurno === btn ? '#1A23DF' : '#fff',
                                                    color: filtroTurno === btn ? '#fff' : '#333',
                                                    borderRadius: '20px',
                                                    cursor: 'pointer',
                                                    fontWeight: filtroTurno === btn ? 'bold' : 'normal',
                                                    fontSize: '13px',
                                                    transition: 'all 0.2s',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                {btn}
                                            </button>
                                        ))}
                                    </div>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                                    {itensPaginaAtual.map((item, index) => (
                                        <div key={index} style={{ border: '1px solid #e0e0e0', borderRadius: '12px', padding: '15px 20px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <span style={{ fontWeight: 'bold', color: '#1A23DF', fontSize: '15px' }}>{item.professor}</span>
                                                <svg onClick={() => handleOpenModal(item)} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#1A23DF', cursor: 'pointer' }}>
                                                    <circle cx="12" cy="12" r="10"></circle>
                                                    <line x1="12" y1="16" x2="12" y2="12"></line>
                                                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                                                </svg>
                                            </div>

                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', fontSize: '13px', color: '#888', alignItems: 'center' }}>
                                                <span style={{ minWidth: '45px' }}>S{item.semestre?.replace('º', '')} &nbsp;T{item.turma?.replace('Turma ', '')}</span>
                                                <span style={{ minWidth: '150px', flex: '1 0 auto' }}>Tipo Atividade: <strong style={{ color: '#555', fontWeight: 'bold' }}>{item.tipo_atividade_abreviatura}</strong></span>
                                                <span style={{ minWidth: '250px', flex: '2 1 0%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Aula: <span style={{ color: '#555' }} title={item.titulo_aula}>{item.titulo_aula}</span></span>
                                                <span style={{ minWidth: '200px', flex: '1 1 0%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Local: <span style={{ color: '#555' }} title={item.local}>{item.local}</span></span>

                                                <span style={{ minWidth: '150px', flex: '1 0 auto', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Grupos: <span style={{ color: '#555' }}>{item.grupos}</span></span>

                                                {item.inicio && item.fim ? (
                                                    <div style={{ minWidth: '110px', display: 'flex', alignItems: 'center', color: '#1A23DF', fontWeight: '600' }}>
                                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '6px' }}>
                                                            <circle cx="12" cy="12" r="10"></circle>
                                                            <polyline points="12 6 12 12 16 14"></polyline>
                                                        </svg>
                                                        <span style={{ color: '#1A23DF' }}>{item.inicio.slice(0, 5)} - {item.fim.slice(0, 5)}</span>
                                                    </div>
                                                ) : (
                                                    <span style={{ minWidth: '110px' }}></span>
                                                )}

                                                <span style={{ minWidth: '50px' }}>C.H: <span style={{ color: '#555' }}>{item.duracao_minima}</span></span>
                                            </div>
                                        </div>
                                    ))}
                                    {itensPaginaAtual.length === 0 && (
                                        <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>Nenhuma aula encontrada para este filtro.</div>
                                    )}
                                </div>

                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '30px', gap: '15px', color: '#666', fontSize: '14px' }}>
                                    <div style={{ display: 'flex', gap: '6px' }}>
                                        <button onClick={() => setPaginaAtual(1)} disabled={paginaAtual === 1} style={{ border: 'none', background: paginaAtual === 1 ? '#767FEF' : '#1A23DF', color: '#fff', borderRadius: '4px', width: '28px', height: '28px', cursor: paginaAtual === 1 ? 'not-allowed' : 'pointer', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 }}>{"<<"}</button>
                                        <button onClick={handlePreviousPage} disabled={paginaAtual === 1} style={{ border: 'none', background: paginaAtual === 1 ? '#767FEF' : '#1A23DF', color: '#fff', borderRadius: '4px', width: '28px', height: '28px', cursor: paginaAtual === 1 ? 'not-allowed' : 'pointer', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 }}>{"<"}</button>
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <span>Página</span>
                                        <input
                                            type="number"
                                            value={paginaAtual}
                                            onChange={(e) => {
                                                const val = parseInt(e.target.value);
                                                if (val >= 1 && val <= totalPaginas) setPaginaAtual(val);
                                            }}
                                            style={{ width: '60px', textAlign: 'center', border: '1px solid #ccc', borderRadius: '15px', padding: '4px', lineHeight: '1' }}
                                        />
                                        <span>de {totalPaginas}</span>
                                    </div>

                                    <div style={{ display: 'flex', gap: '6px' }}>
                                        <button onClick={handleNextPage} disabled={paginaAtual === totalPaginas || totalPaginas === 0} style={{ border: 'none', background: (paginaAtual === totalPaginas || totalPaginas === 0) ? '#767FEF' : '#1A23DF', color: '#fff', borderRadius: '4px', width: '28px', height: '28px', cursor: (paginaAtual === totalPaginas || totalPaginas === 0) ? 'not-allowed' : 'pointer', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 }}>{">"}</button>
                                        <button onClick={() => setPaginaAtual(totalPaginas)} disabled={paginaAtual === totalPaginas || totalPaginas === 0} style={{ border: 'none', background: (paginaAtual === totalPaginas || totalPaginas === 0) ? '#767FEF' : '#1A23DF', color: '#fff', borderRadius: '4px', width: '28px', height: '28px', cursor: (paginaAtual === totalPaginas || totalPaginas === 0) ? 'not-allowed' : 'pointer', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 }}>{">>"}</button>
                                    </div>

                                    <span style={{ marginLeft: '15px' }}>
                                        Registros: {professoresFiltrados.length > 0 ? ((paginaAtual - 1) * itensPorPagina + 1) : 0} a {Math.min(paginaAtual * itensPorPagina, professoresFiltrados.length)} de {professoresFiltrados.length}
                                    </span>
                                </div>
                            </>
                        ) : (
                            <div style={{ textAlign: 'center', padding: '40px 20px', color: '#666' }}>
                                <h4 style={{ fontWeight: 'bold', marginBottom: '20px', color: '#1a1a1a' }}>Professores com Aula</h4>
                                <p>Nenhum professor com aula encontrado para o filtro selecionado.</p>
                            </div>
                        )}
                    </div>
                </Col>

                <Col md="12">
                    <div style={{ backgroundColor: '#fff', borderRadius: '8px', padding: '20px', margin: '0 20px 20px 20px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', border: '1px solid #e0e0e0' }}>
                        {provasPendentes && provasPendentes.length > 0 ? (
                            <>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                                    <h4 style={{ fontWeight: 'bold', margin: '0', color: '#1a1a1a' }}>Provas Pendentes de Envio</h4>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                    {provasPaginaAtual.map((item, index) => (
                                        <div key={index} style={{ border: '1px solid #e0e0e0', borderRadius: '8px', padding: '12px 20px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <span style={{ fontWeight: 'bold', color: '#1A23DF', fontSize: '15px' }}>{item.professor}</span>
                                                {item.dias_expirados === 0 ? (
                                                    <span style={{ backgroundColor: '#FFF3CD', color: '#856404', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: 'bold' }}>Vence hoje</span>
                                                ) : item.dias_expirados > 0 ? (
                                                    <span style={{ backgroundColor: '#F8D7DA', color: '#721C24', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: 'bold' }}>{item.dias_expirados} {item.dias_expirados === 1 ? 'dia' : 'dias'}</span>
                                                ) : (
                                                    <span style={{ backgroundColor: '#D4EDDA', color: '#155724', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: 'bold' }}>No prazo</span>
                                                )}
                                            </div>

                                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', color: '#888', alignItems: 'center', flexWrap: 'wrap', gap: '15px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flex: '1 1 300px', minWidth: '200px' }}>
                                                    {item.semestre && <span style={{ color: '#555' }}>S{item.semestre.toString().replace('º', '')}</span>}
                                                    <span><span style={{ color: '#bbb' }}>Nome Prova:</span> <span style={{ color: '#555' }}>{item.titulo_prova || item.disciplina || '-'}</span></span>
                                                </div>
                                                <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', flex: '0 1 auto' }}>
                                                    <span><span style={{ color: '#bbb' }}>Solicitação:</span> <span style={{ color: '#555' }}>{item.data_solicitacao_conteudo}</span></span>
                                                    <span><span style={{ color: '#bbb' }}>Limite:</span> <span style={{ color: '#555' }}>{item.data_limite_envio_questoes}</span></span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '30px', gap: '15px', color: '#666', fontSize: '14px' }}>
                                    <div style={{ display: 'flex', gap: '6px' }}>
                                        <button onClick={() => setPaginaAtualProvas(1)} disabled={paginaAtualProvas === 1} style={{ border: 'none', background: paginaAtualProvas === 1 ? '#767FEF' : '#1A23DF', color: '#fff', borderRadius: '4px', width: '28px', height: '28px', cursor: paginaAtualProvas === 1 ? 'not-allowed' : 'pointer', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 }}>{"<<"}</button>
                                        <button onClick={handlePreviousPageProvas} disabled={paginaAtualProvas === 1} style={{ border: 'none', background: paginaAtualProvas === 1 ? '#767FEF' : '#1A23DF', color: '#fff', borderRadius: '4px', width: '28px', height: '28px', cursor: paginaAtualProvas === 1 ? 'not-allowed' : 'pointer', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 }}>{"<"}</button>
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <span>Página</span>
                                        <input
                                            type="number"
                                            value={paginaAtualProvas}
                                            onChange={(e) => {
                                                const val = parseInt(e.target.value);
                                                if (val >= 1 && val <= totalPaginasProvas) setPaginaAtualProvas(val);
                                            }}
                                            style={{ width: '60px', textAlign: 'center', border: '1px solid #ccc', borderRadius: '15px', padding: '4px', lineHeight: '1' }}
                                        />
                                        <span>de {totalPaginasProvas}</span>
                                    </div>

                                    <div style={{ display: 'flex', gap: '6px' }}>
                                        <button onClick={handleNextPageProvas} disabled={paginaAtualProvas === totalPaginasProvas || totalPaginasProvas === 0} style={{ border: 'none', background: (paginaAtualProvas === totalPaginasProvas || totalPaginasProvas === 0) ? '#767FEF' : '#1A23DF', color: '#fff', borderRadius: '4px', width: '28px', height: '28px', cursor: (paginaAtualProvas === totalPaginasProvas || totalPaginasProvas === 0) ? 'not-allowed' : 'pointer', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 }}>{">"}</button>
                                        <button onClick={() => setPaginaAtualProvas(totalPaginasProvas)} disabled={paginaAtualProvas === totalPaginasProvas || totalPaginasProvas === 0} style={{ border: 'none', background: (paginaAtualProvas === totalPaginasProvas || totalPaginasProvas === 0) ? '#767FEF' : '#1A23DF', color: '#fff', borderRadius: '4px', width: '28px', height: '28px', cursor: (paginaAtualProvas === totalPaginasProvas || totalPaginasProvas === 0) ? 'not-allowed' : 'pointer', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 }}>{">>"}</button>
                                    </div>

                                    <span style={{ marginLeft: '15px' }}>
                                        Registros: {provasPendentes.length > 0 ? ((paginaAtualProvas - 1) * itensPorPaginaProvas + 1) : 0} a {Math.min(paginaAtualProvas * itensPorPaginaProvas, provasPendentes.length)} de {provasPendentes.length}
                                    </span>
                                </div>
                            </>
                        ) : (
                            <div style={{ textAlign: 'center', padding: '40px 20px', color: '#666' }}>
                                <h4 style={{ fontWeight: 'bold', marginBottom: '20px', color: '#1a1a1a' }}>Provas Pendentes de Envio</h4>
                                <p>Nenhuma prova pendente encontrada para o filtro selecionado.</p>
                            </div>
                        )}
                    </div>
                </Col>


                <Col md="12">
                    <div style={{ backgroundColor: '#fff', borderRadius: '8px', padding: '20px', margin: '0 20px 20px 20px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', border: '1px solid #e0e0e0', minHeight: '30rem' }}>
                        {acessosProfessores && acessosProfessores.some(arr => arr && arr.length > 0) ? (
                            <BarGraph
                                title={'Acessos do Professor'}
                                buttons={true}
                                data={acessosProfessores}
                            />
                        ) : (
                            <div style={{ textAlign: 'center', color: '#666', padding: '100px 0' }}>
                                <h4 style={{ fontWeight: 'bold', marginBottom: '20px', color: '#1a1a1a' }}>Acessos do Professor</h4>
                                <p>Nenhum dado de acesso encontrado para o período selecionado.</p>
                            </div>
                        )}
                    </div>
                </Col>
            </NewLoader>

            <Modal isOpen={modalAtividadeOpen} toggle={toggleModalAtividade} size="lg" centered style={{ maxWidth: '95%', width: '800px' }}>
                <ModalBody style={{ padding: '30px', maxHeight: '80vh', overflowY: 'auto' }}>
                    {atividadeSelecionada && (
                        <div>
                            <div style={{ position: 'relative', marginBottom: '25px', borderBottom: '1px solid #f0f0f0', paddingBottom: '15px', textAlign: 'center' }}>
                                <h5 style={{ fontWeight: 'bold', margin: 0, fontSize: '16px', color: '#1a1a1a', display: 'inline-block' }}>Detalhes das Aulas</h5>
                                <svg onClick={toggleModalAtividade} width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ cursor: 'pointer', color: '#1A23DF', position: 'absolute', right: 0, top: '-2px' }}>
                                    <line x1="18" y1="6" x2="6" y2="18"></line>
                                    <line x1="6" y1="6" x2="18" y2="18"></line>
                                </svg>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                                <span style={{ fontSize: '16px', color: '#888' }}>Tipo de Atividade: <strong style={{ color: '#1a1a1a' }}>{atividadeSelecionada.tipo_atividade_nome}</strong></span>
                                <span style={{ fontSize: '15px', color: '#888' }}>{atividadeSelecionada.total_aulas} aula(s)</span>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                                {professoresComAulaCompleto.filter(p => 
                                    (p.tipo_atividade_id == atividadeSelecionada.tipo_atividade_id) || 
                                    (p.tipo_atividade_abreviatura?.trim() === atividadeSelecionada.tipo_atividade_abreviatura?.trim())
                                ).map((item, index) => (
                                    <div key={index} style={{ border: '1px solid #e0e0e0', borderRadius: '12px', padding: '15px 20px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <span style={{ fontWeight: 'bold', color: '#333', fontSize: '15px' }}>{item.professor}</span>
                                            <svg onClick={() => handleOpenModal(item)} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#1A23DF', cursor: 'pointer' }}>
                                                <circle cx="12" cy="12" r="10"></circle>
                                                <line x1="12" y1="16" x2="12" y2="12"></line>
                                                <line x1="12" y1="8" x2="12.01" y2="8"></line>
                                            </svg>
                                        </div>

                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', fontSize: '13px', color: '#888', alignItems: 'center' }}>
                                            <span style={{ width: '70px', flexShrink: 0 }}>S{item.semestre?.replace('º', '')}{item.turma ? ` T${item.turma.replace('Turma ', '')}` : ''}</span>
                                            <span style={{ width: '90px', flexShrink: 0, color: '#555', fontWeight: 'bold' }}>{item.data_ptbr}</span>
                                            <span style={{ width: '150px', flexShrink: 0 }}>Tipo Atividade: <strong style={{ color: '#555', fontWeight: 'bold' }}>{item.tipo_atividade_abreviatura}</strong></span>
                                            <span style={{ maxWidth: '400px', flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Aula: <span style={{ color: '#555' }}>{item.titulo_aula}</span></span>
                                        </div>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', fontSize: '13px', color: '#888', alignItems: 'center' }}>
                                            <span style={{ width: '250px', flexShrink: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Local: <span style={{ color: '#555' }}>{item.local}</span></span>
                                            <span style={{ width: '150px', flexShrink: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Grupos: <span style={{ color: '#555' }}>{item.grupos}</span></span>

                                            {item.inicio && item.fim ? (
                                                <div style={{ width: '110px', flexShrink: 0, display: 'flex', alignItems: 'center', color: '#1A23DF', fontWeight: '600' }}>
                                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '6px' }}>
                                                        <circle cx="12" cy="12" r="10"></circle>
                                                        <polyline points="12 6 12 12 16 14"></polyline>
                                                    </svg>
                                                    <span style={{ color: '#1A23DF' }}>{item.inicio.slice(0, 5)} - {item.fim.slice(0, 5)}</span>
                                                </div>
                                            ) : (
                                                <span style={{ width: '110px', flexShrink: 0 }}></span>
                                            )}
                                            {/* item log removed */}
                                            <span style={{ width: '50px', flexShrink: 0 }}>C.H: <span style={{ color: '#555' }}>{item.duracao_minima}</span></span>
                                        </div>
                                    </div>
                                ))}
                                {professoresComAulaCompleto.filter(p => 
                                    (p.tipo_atividade_id == atividadeSelecionada.tipo_atividade_id) || 
                                    (p.tipo_atividade_abreviatura?.trim() === atividadeSelecionada.tipo_atividade_abreviatura?.trim())
                                ).length === 0 && (
                                    <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>Nenhuma aula detalhada encontrada para esta atividade.</div>
                                )}
                            </div>
                        </div>
                    )}
                </ModalBody>
            </Modal>

            <Modal isOpen={modalOpen} toggle={toggleModal} size="lg" centered style={{ maxWidth: '95%', width: '750px' }}>
                <ModalBody style={{ padding: '30px' }}>
                    {aulaSelecionada && (
                        <div>
                            <div style={{ position: 'relative', marginBottom: '20px', borderBottom: '1px solid #f0f0f0', paddingBottom: '15px', textAlign: 'center' }}>
                                <h5 style={{ fontWeight: 'bold', margin: 0, fontSize: '15px', color: '#1a1a1a', display: 'inline-block' }}>Detalhes da Aula</h5>
                                <svg onClick={toggleModal} width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ cursor: 'pointer', color: '#1A23DF', position: 'absolute', right: 0, top: '-2px' }}>
                                    <line x1="18" y1="6" x2="6" y2="18"></line>
                                    <line x1="6" y1="6" x2="18" y2="18"></line>
                                </svg>
                            </div>
                            <div style={{ marginBottom: '25px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                <span style={{ fontWeight: 'bold', color: '#1a1a1a', fontSize: '18px' }}>Prof. {aulaSelecionada.professor}</span>

                                <div style={{ display: 'flex', gap: '20px', fontSize: '14px', color: '#666', flexWrap: 'wrap', alignItems: 'center' }}>
                                    <span style={{ fontWeight: 'bold', color: '#444' }}>S{aulaSelecionada.semestre?.replace('º', '')} &nbsp;T{aulaSelecionada.turma?.replace('Turma ', '')}</span>
                                    <span style={{ fontWeight: 'bold', color: '#444' }}>{aulaSelecionada.data_ptbr}</span>
                                    <span><strong style={{ color: '#888', fontWeight: 'normal' }}>Tipo Atividade:</strong> <strong style={{ color: '#444' }}>{aulaSelecionada.tipo_atividade_abreviatura}</strong></span>
                                </div>

                                <div style={{ display: 'flex', gap: '20px', fontSize: '14px', color: '#666', flexWrap: 'wrap', alignItems: 'center' }}>
                                    <span style={{ flex: 1 }}><strong style={{ color: '#888', fontWeight: 'normal' }}>Aula:</strong> <strong style={{ color: '#444' }}>{aulaSelecionada.titulo_aula}</strong></span>
                                </div>

                                <div style={{ display: 'flex', gap: '20px', fontSize: '14px', color: '#666', flexWrap: 'wrap', alignItems: 'center' }}>
                                    <span><strong style={{ color: '#888', fontWeight: 'normal' }}>Local:</strong> <strong style={{ color: '#444' }}>{aulaSelecionada.local}</strong></span>
                                    <span><strong style={{ color: '#888', fontWeight: 'normal' }}>Grupos:</strong> <strong style={{ color: '#444' }}>{aulaSelecionada.grupos}</strong></span>
                                    <span><strong style={{ color: '#888', fontWeight: 'normal' }}>C.H:</strong> <strong style={{ color: '#444' }}>{aulaSelecionada.duracao_minima}</strong></span>
                                </div>

                                {(aulaSelecionada.inicio || aulaSelecionada.fim) && (
                                    <>
                                        <div style={{ display: 'flex', gap: '20px', fontSize: '14px', color: '#666', flexWrap: 'wrap', alignItems: 'center' }}>
                                            {aulaSelecionada.inicio && <span><strong style={{ color: '#888', fontWeight: 'normal' }}>Horário de Início:</strong> <strong style={{ color: '#444' }}>{aulaSelecionada.inicio.slice(0, 5)}</strong></span>}
                                            {aulaSelecionada.fim && <span><strong style={{ color: '#888', fontWeight: 'normal' }}>Horário de Fim:</strong> <strong style={{ color: '#444' }}>{aulaSelecionada.fim.slice(0, 5)}</strong></span>}
                                        </div>
                                        <div style={{ display: 'flex', gap: '20px', fontSize: '14px', color: '#666', flexWrap: 'wrap', alignItems: 'center' }}>
                                            {aulaSelecionada.intervalo_inicio && <span><strong style={{ color: '#888', fontWeight: 'normal' }}>Início do Intervalo:</strong> <strong style={{ color: '#444' }}>{aulaSelecionada.intervalo_inicio.slice(0, 5)}</strong></span>}
                                            {aulaSelecionada.intervalo_fim && <span><strong style={{ color: '#888', fontWeight: 'normal' }}>Fim do Intervalo:</strong> <strong style={{ color: '#444' }}>{aulaSelecionada.intervalo_fim.slice(0, 5)}</strong></span>}
                                        </div>
                                    </>
                                )}
                            </div>

                            <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: '20px' }}>
                                {aulaSelecionada.motivo_cancelamento && (
                                    <div style={{ marginBottom: '15px' }}>
                                        <span style={{ fontWeight: 'bold', color: '#f44336', fontSize: '15px', display: 'block' }}>
                                            Motivo do Cancelamento : {aulaSelecionada.motivo_cancelamento}
                                        </span>
                                    </div>
                                )}
                                <span style={{ fontWeight: 'bold', color: '#888', fontSize: '14px', marginBottom: '15px', display: 'block' }}>Objetivos de Aprendizagem</span>
                                <div style={{ fontSize: '15px', color: '#333', lineHeight: '1.6' }}>
                                    {aulaSelecionada.objetivo_aprendizagem ? (
                                        <div dangerouslySetInnerHTML={{ __html: aulaSelecionada.objetivo_aprendizagem }} />
                                    ) : (
                                        "Sem objetivos"
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </ModalBody>
            </Modal>
        </Row>
    )
}

const mapDispatchToProps = (dispatch) => {
    return {
        desativarModal: () => dispatch(actionsRedux.desativarModalSubFuncionalidade()),
        ativarAlert: (tipo, acao) => dispatch(actionsRedux.ativarAlert(tipo, acao))
    }
}

const mapStateToProps = (state) => {
    return {
        dashboard: state.subFuncionalidades.dashboard,
        estruturaModal: state.subFuncionalidades.estruturaModal,
        estadoModal: state.subFuncionalidades.estadoModal,
        adicionar: state.subFuncionalidades.adicionar,
        editarFunc: state.subFuncionalidades.editar,
        tipoAcao: state.subFuncionalidades.tipoAcao,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)